import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import pathname from '../../../constants/pathname'
import {
  delSettingFormProjectAppendix,
  saveSettingFormProjectAppendix,
  updateSettingFormProjectAppendixName,
  updateSettingFormProjectAppendixSeq,
} from '../../../redux/actions/subProjectFormSetting'
import { downloadSubprojectFile } from '../../../redux/actions/subProject'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function AppendixSettingWidget(props) {
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [notiMsg, setNotiMsg] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      const response = await updateSettingFormProjectAppendixName(formId, request)
      if (response) {
        setIsEditErr(false)
        setFormSchema(response)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      const response = await saveSettingFormProjectAppendix(formId, request)
      if (response) {
        setFormSchema(response)
        setIsUploadErr(false)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      const response = await delSettingFormProjectAppendix(formId, id)

      if (response) {
        setFormSchema(response)
        setIsDeleteError(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await downloadSubprojectFile(fileObj.path)

    var fileNames = fileObj.name.split('.')
    var fileName = fileObj.label.replace(' ', '')
    if (fileNames) {
      fileName += '.' + fileNames[fileNames.length - 1] || ''
    }

    downloadFile(file, fileName)

    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await downloadSubprojectFile(fileObj.path)
    previewFile(file, fileObj.name)

    doneLoading()
  }

  const onUpload = (data) => {
    console.log('onSubmit data', data)
    const file = data[formSchema.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('attachDetail', data.attachDetail)

    handleUpload(formData)
  }

  const onUpdate = (file, newName, detail) => {
    let req = {
      id: file.id,
      name: newName,
      detail: detail,
      numSeq: file.seqNo,
    }

    handleUpdate(req)
  }

  const onDelete = (index) => {
    let id = formSchema.attachFiles.value[index]?.id
    handleDelete(id)
  }

  const onChangSeqNo = async (data, seqNo, index, type) => {
    startLoading()
    setIsLoading(true)
    try {
      let newSeqNo
      if (type == 'UP') {
        newSeqNo = formSchema.attachFiles.value[index - 1]?.seqNo || seqNo
      } else {
        newSeqNo = formSchema.attachFiles.value[index + 1]?.seqNo || seqNo
      }

      const response = await updateSettingFormProjectAppendixSeq(formId, data.id, newSeqNo)
      if (response) {
        // let _schema = formSchema
        // _schema.attachFiles = response
        setFormSchema(response)
        // setIsUploadErr(false)
      } else {
        // setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      // setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      <AttachFilesForm
        schema={formSchema.attachFiles}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        onSubmit={handleSubmit(onUpload)}
        onDelete={onDelete}
        onUpdate={onUpdate}
        onDownload={onDownload}
        onPreview={onPreview}
        onChangSeqNo={onChangSeqNo}
        isChangSeqNo={true}
        isEditErr={isEditErr}
        isUploadErr={isUploadErr}
        isDeleteError={isDeleteError}
        loading={isLoading}
        buttonText={formSchema.buttonText}
        buttonTextAlign="right"
      />

      <hr />
      {/* {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )} */}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.appendix}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
